import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Logo = () => {
  return (
    <>
      <motion.div
        className="max-w-2xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.65, delay: 0.0, ease: "easeInOut" }}
      >
        <div className="absolute top-6 left-10 scale-110 drop-shadow-xl dark:drop-shadow flex items-center">
          <Link
            to="/"
            className="text-xl font-bold font-['minecraft'] hover:drop-shadow-2xl transition-all duration-1000 flex items-center "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="125"
              height="125 "
              viewBox="0 0 500 500"
              className=""
            >
              <g
                transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
                fill="#ffffff"
                stroke="none"
              >
                <path
                  d="M1599 3850 c-114 -20 -209 -90 -250 -184 -31 -70 -38 -222 -15 -334
46 -225 167 -477 360 -746 39 -55 74 -106 79 -113 5 -7 -58 -143 -163 -353
-93 -187 -170 -342 -170 -345 0 -3 96 -5 213 -5 l212 0 93 186 93 186 167
-164 c413 -403 847 -683 1201 -775 122 -32 280 -35 356 -8 223 78 281 327 159
682 -75 218 -231 479 -442 741 l-76 94 142 284 c78 156 142 286 142 289 0 3
-96 5 -213 5 l-212 0 -68 -135 -67 -136 -113 103 c-422 389 -813 629 -1152
708 -98 23 -214 31 -276 20z m399 -120 c282 -68 697 -326 1022 -637 l102 -98
-139 -280 c-101 -201 -142 -274 -146 -260 -3 11 -52 196 -107 410 -55 215
-103 398 -106 408 -5 16 -22 17 -217 15 l-212 -3 -170 -337 c-93 -186 -173
-338 -176 -338 -13 0 -154 227 -210 336 -176 347 -186 644 -25 752 27 17 62
36 80 41 58 17 216 12 304 -9z m1475 -1132 c391 -503 524 -988 320 -1168 -68
-59 -123 -74 -262 -68 -99 4 -132 11 -222 41 -145 49 -301 129 -460 236 -74
50 -145 99 -159 110 l-25 21 140 0 140 0 228 455 c125 250 229 455 231 455 3
0 34 -37 69 -82z m-1099 -332 c47 -176 84 -321 82 -324 -2 -2 -79 70 -171 160
l-167 163 81 164 c45 90 84 162 86 160 2 -2 42 -148 89 -323z"
                />
              </g>
            </svg>
            <div className="flex flex-col space-y-[-0.4rem]"></div>
          </Link>
        </div>
      </motion.div>
    </>
  );
};

export default Logo;
